var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16342 32 0 24.8366 0 16C0 7.16342 7.16342 0 16 0C24.8366 0 32 7.16342 32 16ZM14.1493 24.4719L26.0203 12.6009C26.4234 12.1978 26.4234 11.5442 26.0203 11.1411L24.5605 9.68129C24.1574 9.27813 23.5037 9.27813 23.1006 9.68129L13.4194 19.3625L8.89942 14.8425C8.49632 14.4394 7.84271 14.4394 7.43955 14.8425L5.97974 16.3023C5.57664 16.7054 5.57664 17.359 5.97974 17.7621L12.6894 24.4718C13.0926 24.875 13.7461 24.875 14.1493 24.4719Z",
    fill: "#1ABC9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.f4781d0b52bc54aef52c3efe834029bb.svg";
export { ForwardRef as ReactComponent };